const BASE_URL =process.env.REACT_APP_BASE_URL


export const getdata ={
    DATA_API :BASE_URL + "/getData"
};